declare const __PROFENZ_SOURCE_SHA__: string;

export function formatServingBuild(sourceSha: string | null | undefined): string | null {
  return sourceSha !== null && sourceSha !== undefined && /^[0-9a-f]{40}$/.test(sourceSha)
    ? `Build ${sourceSha.slice(0, 7)}`
    : null;
}

export function ServingBuildIdentity({sourceSha = __PROFENZ_SOURCE_SHA__}: {sourceSha?: string | null} = {}) {
  const label = formatServingBuild(sourceSha);
  return label ? <p className="serving-build-identity" aria-label="Application build">{label}</p> : null;
}
